import * as React from 'react';

import cn from 'classnames';

import {
	IBrandMenuItemProps,
	IBrandMenuItemState,
} from './types';

import * as s from './BrandMenuItem.scss';

export class BrandMenuItem extends React.Component<IBrandMenuItemProps, IBrandMenuItemState> {

	onClick = () => {
		const {
			id,
			onClick,
		} = this.props;

		onClick(id);
	};

	render() {
		const {
			title,
			isActive,
			className,
			hideThreshold,
			blockRef,
		} = this.props;

		return (
			<div
				ref={blockRef}
				className={cn(s.block, className, {
					[s.active]: isActive,
					[s.hiddenAt375]: hideThreshold && hideThreshold <= 375,
				})}
				onClick={this.onClick}
			>
				<div className={s.mark}/>
				<div className={s.title}>
					{title}
				</div>
			</div>
		);
	}

}
